import { render, staticRenderFns } from "./Boolean.vue?vue&type=template&id=70c1365b&"
import script from "./Boolean.vue?vue&type=script&lang=js&"
export * from "./Boolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports